import styled from 'styled-components';

const Container = styled.div`
  flex: 5;
  display: flex;
  flex-direction: row;
`;

export { Container };
